"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UINestedNav = _interopRequireDefault(require("UIComponents/nav/UINestedNav"));

var _UINestedNavItem = _interopRequireDefault(require("UIComponents/nav/UINestedNavItem"));

var _NavItemTitle = _interopRequireDefault(require("settings-ui-nav/components/NavItemTitle"));

var SettingsNav =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(SettingsNav, _Component);

  function SettingsNav() {
    (0, _classCallCheck2.default)(this, SettingsNav);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SettingsNav).apply(this, arguments));
  }

  (0, _createClass2.default)(SettingsNav, [{
    key: "getHandleClick",
    value: function getHandleClick(navItem) {
      var _this$props = this.props,
          onClickHandler = _this$props.onClickHandler,
          settingsApp = _this$props.settingsApp,
          track = _this$props.track;
      return function (evt) {
        if (typeof track === 'function') {
          track('settingsNavInteraction', {
            settingsGroup: navItem.settingsGroup,
            settingsLink: navItem.trackingScreen,
            settingsApp: settingsApp
          });
        }

        onClickHandler(evt, navItem);
      };
    }
  }, {
    key: "renderNavMenuItem",
    value: function renderNavMenuItem(navItem) {
      var _this = this;

      var pathname = this.props.pathname;

      var titleComponent = _react.default.createElement(_NavItemTitle.default, {
        navItem: navItem
      });

      if (navItem.children.length) {
        return _react.default.createElement(_UINestedNavItem.default, {
          "data-selenium-id": navItem.label,
          title: titleComponent,
          key: navItem.label,
          defaultOpen: navItem.matchesPath(pathname)
        }, navItem.children.map(function (child) {
          return _this.renderNavMenuItem(child);
        }));
      }

      return _react.default.createElement(_UINestedNavItem.default, {
        "data-selenium-id": navItem.label,
        title: titleComponent,
        key: navItem.label,
        value: navItem.path,
        href: navItem.path,
        onClick: this.getHandleClick(navItem)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          pathname = _this$props2.pathname,
          config = _this$props2.config;
      var matchingNavItem = config.find(function (navItem) {
        return navItem.matchesPath(pathname);
      });
      var matchingHref = matchingNavItem ? matchingNavItem.getHrefMatchingPath(pathname) : null;
      return _react.default.createElement(_UINestedNav.default, {
        value: matchingHref,
        "data-reagan-test": "settings-nav"
      }, config.map(function (navItem) {
        return _this2.renderNavMenuItem(navItem);
      }));
    }
  }]);
  return SettingsNav;
}(_react.Component);

SettingsNav.defaultProps = {
  onClickHandler: function onClickHandler() {
    /* noop - results in normal link behavior */
  }
};
SettingsNav.propTypes = {
  pathname: _react.PropTypes.string.isRequired,
  onClickHandler: _react.PropTypes.func,
  settingsApp: _react.PropTypes.string,
  config: _react.PropTypes.array.isRequired,
  track: _react.PropTypes.func.isRequired
};
var _default = SettingsNav;
exports.default = _default;
module.exports = exports.default;